var map = {
	"./adventure.svg": "d2aa",
	"./adventure2.svg": "bc39",
	"./blueprint.svg": "9a9b",
	"./blueprint2.svg": "8553",
	"./book.svg": "1db0",
	"./book2.svg": "1b19",
	"./exam.svg": "8a19",
	"./exam2.svg": "e63c",
	"./exterior.svg": "15cb",
	"./exterior2.svg": "4a6f",
	"./face.svg": "00aa",
	"./face2.svg": "6030",
	"./fold.svg": "c93a",
	"./furniture.svg": "ba14",
	"./furniture2.svg": "f3d3",
	"./gonggao.svg": "66b5",
	"./gonggao2.svg": "405a",
	"./home.svg": "cc6b",
	"./horse.svg": "7628",
	"./horse2.svg": "8505",
	"./left.svg": "f39d",
	"./manufacture.svg": "dfc0",
	"./manufacture2.svg": "fd05",
	"./op.svg": "b5dc",
	"./open.svg": "15bb",
	"./pet.svg": "d928",
	"./pet2.svg": "a245",
	"./price.svg": "a778",
	"./price2.svg": "8814",
	"./reputation.svg": "8301",
	"./reputation2.svg": "2f2a",
	"./setting.svg": "1b4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "45c5";